import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconSend } from "@tabler/icons-react";
import {
  Button,
  Image,
  Skeleton,
  Stack,
  Text,
} from "@advarra-engineering/advarra-design-system-react";
import resendInvite from "../rest/resendInvite";

interface InvitationExpiredProps {
  token: string;
}
export function InvitationExpiredPage(props: InvitationExpiredProps) {
  const { t } = useTranslation();
  const [resendIcon, setResendIcon] = useState("InvitationExpiredIcon.png");
  const [titleValue, setTitleValue] = useState(t("invitation-expired.title"));
  const [messageValue, setMessageValue] = useState(
    t("invitation-expired.message"),
  );
  const [isLoading, setLoading] = useState(false);

  const handleResendInvite = () => {
    setLoading(true);
    resendInvite(props.token)
      .then((result) => {
        if (result.status === "ok") {
          handleSuccess();
        } else {
          handleFailure();
        }
      })
      .catch((__error) => {
        handleFailure();
      });
  };

  const handleSuccess = () => {
    setResendIcon("./InvitationSentIcon.png");
    setTitleValue(t("invitation-expired.title-success"));
    setMessageValue(t("invitation-expired.message-success"));
    setLoading(false);
  };

  const handleFailure = () => {
    setTitleValue(t("invitation-expired.title-failure"));
    setMessageValue(t("invitation-expired.message-failure"));
    setLoading(false);
  };

  return (
    <Stack justify="center" align="center">
      {isLoading ? (
        <Skeleton height={145} width={145} />
      ) : (
        <Image src={resendIcon} height="145px" width="145px" />
      )}
      <Text size="xl" data-testid="invitation-expired-title">
        {isLoading ? <Skeleton height="40" width="300" /> : titleValue}
      </Text>
      <Text
        size="sm"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          lineHeight: "initial",
        }}
        data-testid="invitation-expired-message"
      >
        {isLoading ? <Skeleton height="25" width="300" /> : messageValue}
      </Text>
      <Button
        onClick={() => handleResendInvite()}
        type="submit"
        loading={isLoading}
        data-testid="resend-invitation-button"
        leftIcon={<IconSend />}
        size="md"
        top={30}
      >
        {isLoading
          ? t("invitation-expired.button-text-loading")
          : t("invitation-expired.button-text")}
      </Button>
    </Stack>
  );
}
